/**
 * CMS/API sometimes returns `https:/host/path` (one slash). Browsers resolve that
 * as a path relative to the current URL → e.g. /fashion/https:/host/path
 */
export function normalizeFashionNavLink(link) {
  if (!link || link === "#") return null;
  let u = String(link).trim();
  if (/^https:\/[^/]/.test(u)) u = `https://${u.slice("https:/".length)}`;
  if (/^http:\/[^/]/.test(u)) u = `http://${u.slice("http:/".length)}`;
  return u;
}
